import 'expose-loader?I18n!i18n-js' // Imports i18n-js and exposes it globally as I18n
import '../lib/i18n/translations'

I18n.locale = document.documentElement.lang

export default I18n
